export const SET_SELECTED_SEGMENT_ID = 'SET_SELECTED_SEGMENT_ID';
export const CLEAR_ALL_DATA = 'CLEAR_ALL_DATA';
export const UPDATE_DEVICE_PROFILE = 'UPDATE_DEVICE_PROFILE';

export const CHOOSE_ACTIVE_SHIPMENT = 'CHOOSE_ACTIVE_SHIPMENT';
export const SET_SHIPMENT_DATA = 'SET_SHIPMENT_DATA';
export const CLOSE_ACTIVE_SHIPMENT = 'CLOSE_ACTIVE_SHIPMENT';
export const SHIPMENT_CHANGE_STATUS = 'SHIPMENT_CHANGE_STATUS';
export const ADD_SHIPMENT_SEGMENT_INSURANCE_CERTIFICATE = 'ADD_SHIPMENT_SEGMENT_INSURANCE_CERTIFICATE';
export const CREATE_SHIPMENT_CONVOY = 'CREATE_SHIPMENT_CONVOY';
export const UPDATE_SHIPMENT_CONVOY = 'UPDATE_SHIPMENT_CONVOY';
export const REMOVE_SHIPMENTS_FROM_CONVOY = 'REMOVE_SHIPMENTS_FROM_CONVOY';
export const UPDATE_LOCKDOWN_STATE = 'UPDATE_LOCKDOWN_STATE';
export const FETCH_SHIPMENT_DATA_ERROR = 'FETCH_SHIPMENT_DATA_ERROR';
export const UPDATE_SHIPMENT_ATTACHMENTS_COUNT = 'UPDATE_SHIPMENT_ATTACHMENTS_COUNT';

//shipment list filters
export const SET_SHIPMENT_LIST_FILTER = 'SET_SHIPMENT_LIST_FILTER';
export const CHANGE_SHIPMENT_LIST_FILTER = 'CHANGE_SHIPMENT_LIST_FILTER';
export const RESET_INTERNAL_SHIPMENT_LIST_FILTER = 'RESET_INTERNAL_SHIPMENT_LIST_FILTER';
export const APPLY_SHIPMENTS_LIST_SAVED_FILTER = 'APPLY_SHIPMENTS_LIST_SAVED_FILTER';
export const SET_LAST_UPDATED_AT_SHIPMENTS_FILTER = 'SET_LAST_UPDATED_AT_SHIPMENTS_FILTER';
export const SET_MAP_ATTRIBUTES = 'SET_MAP_ATTRIBUTES';

//shipment list
export const TOGGLE_LIST = 'TOGGLE_LIST';
export const SET_SUV_LIST = 'SET_SUV_LIST';

//chat
export const ADD_NEW_EVENT_CHAT_MESSAGE = 'ADD_NEW_EVENT_CHAT_MESSAGE';
export const READ_NEW_EVENT_CHAT_MESSAGES = 'READ_NEW_EVENT_CHAT_MESSAGES';
export const READ_NEW_SHIPMENT_CHAT_MESSAGES = 'READ_NEW_SHIPMENT_CHAT_MESSAGES';
export const ADD_NEW_SHIPMENT_CHAT_MESSAGE = 'ADD_NEW_SHIPMENT_CHAT_MESSAGE';